<template>
  <section>
    <b-modal :title="title" v-model="open" ref="modal" size="lg">
      <div>
        <div class="form-group">
          <label>{{$t('message.type')}}</label>
          <select v-model="type" class="form-control">
            <option v-if="medium === 'water'" value="cold">{{$t('message.cold_water')}}</option>
            <option v-if="medium === 'water'" value="hot">{{$t('message.hot_water')}}</option>
            <option v-if="medium === 'water'" value="total">{{$t('message.total_water')}}</option>
            <option v-if="medium === 'power'" value="electricity">{{$t('message.electricity')}}</option>
            <option v-if="medium === 'heat'" value="heat">{{$t('message.heat')}}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{$t('message.from')}}</label>
          <date-picker class="period-select" v-model="from" :config="configFrom"></date-picker>
        </div>
        <div class="form-group">
          <label>{{$t('message.to')}}</label>
          <date-picker class="period-select" v-model="to" :config="configTo"></date-picker>
        </div>

      </div>
      <template #footer>
        <b-btn @click="open=false">{{$t('message.close')}}</b-btn>
        <b-btn @click="download('csv')">{{$t('message.download')}} CSV</b-btn>
        <b-btn @click="download('xlsx')">{{$t('message.download')}} Excel</b-btn>
      </template>
    </b-modal>
  </section>
</template>

<script>
    import moment from 'moment'
    import { DatePicker as datePicker } from '../../../ui'
    import mixins from '../../../modules/mixins'

    export default {
        name: 'DownloadTransmitterData',
        mixins: [mixins],
        components: {
            datePicker
        },
        data () {
            return {
                open: false,
                transmitter: null,
                type: 'cold',
                medium: 'water',
                from: moment().subtract(1, 'days').subtract(1, 'day').endOf('day'),
                to: moment().subtract(1, 'days').endOf('day'),
                fromStr: '',
                toStr: '',
                configFrom: {
                    format: 'DD.MM.YYYY',
                    useCurrent: false,
                    locale: 'cs',
                    maxDate: moment().subtract(1, 'days').endOf('day'),
                    useStrict: true,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar-alt',
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-dot-circle',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times'
                    }
                },
                configTo: {
                    format: 'DD.MM.YYYY',
                    useCurrent: false,
                    locale: 'cs',
                    maxDate: moment().subtract(1, 'days').endOf('day'),
                    useStrict: true,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar-alt',
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-dot-circle',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times'
                    }
                }
            }
        },
        computed: {
            title () {
                return this.$t('message.download_transmitter_data') + ' ' + (this.transmitter ? (this.transmitter.name || this.transmitter.serial_number) : '')
            }
        },
        methods: {
            show (transmitter, medium) {
                this.open = true
                this.transmitter = transmitter
                this.medium = medium
                if (medium === 'power') {
                    this.type = 'electricity'
                } else if (medium === 'heat') {
                    this.type = 'heat'
                } else {
                    this.type = 'cold'
                }
            },
            download (format) {
                // this.open = false
                if (!moment(this.from, 'DD.MM.YYYY').isValid()) {
                    this.notify('danger', 'message.invalid_date')
                    return
                }
                if (!moment(this.to, 'DD.MM.YYYY').isValid()) {
                    this.notify('danger', 'message.invalid_date')
                    return
                }
                const reqFrom = moment(this.from, 'DD.MM.YYYY').format('YYYY-MM-DD')
                const reqTo = moment(this.to, 'DD.MM.YYYY').format('YYYY-MM-DD')
                this.fromStr = moment(this.from, 'DD.MM.YYYY').format('DD.MM.YYYY')
                this.toStr = moment(this.to, 'DD.MM.YYYY').format('DD.MM.YYYY')
                const request = {
                    serialNumber: this.resolveSerialNumber(),
                    waterType: this.type,
                    from: reqFrom,
                    to: reqTo,
                    format: format
                }
                window.location = '/api/v2/transmitter-data?organization=' + this.activeOrganization.id + '&format=' + format + '&from=' + reqFrom + '&to=' + reqTo + '&type=' + request.waterType + '&serialNumber=' + request.serialNumber + '&locale=' + this.getLanguage()
            },
            resolveSerialNumber () {
                if (this.transmitter.device_serial) {
                    return this.transmitter.device_serial
                }
                if (this.medium === 'heat') {
                    const decoded = Number(this.transmitter.serial_number)
                    if (Number.isInteger(decoded) && decoded >= 0 && decoded <= 99999999) {
                        return this.encodeITN(decoded)
                    }
                }
                return this.transmitter.serial_number
            }
        }
    }
</script>

<style scoped>

</style>
